import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import HomeSidebar from "./HomeSidebar";
import ModalConfirmLogout from "./ModalConfirmLogout";
import HackerLiveFeed from "./HackerLiveFeed";
import "./AppSidebarLayout.css";

type AppSidebarLayoutProps = {
  children: React.ReactNode;
};

function isFinalGameTable(pathname: string) {
  return (
    pathname.startsWith("/NH/soccer-striker") ||
    pathname.startsWith("/NH/aviator")
  );
}

export default function AppSidebarLayout({ children }: AppSidebarLayoutProps) {
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const showDualLiveFeeds = useMemo(
    () => pathname === "/" || isFinalGameTable(pathname),
    [pathname]
  );

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  return (
    <div className="x88-hub-shell">
      <HomeSidebar
        drawerOpen={menuOpen}
        onLogoutClick={() => setIsShowLogout(true)}
      />
      <button
        type="button"
        className={`hub-drawer-backdrop${menuOpen ? " hub-drawer-backdrop--open" : ""}`}
        aria-label="Đóng menu"
        tabIndex={menuOpen ? 0 : -1}
        onClick={() => setMenuOpen(false)}
      />

      <div className="x88-hub-shell__body">
        <button
          type="button"
          className="hub-menu-btn"
          aria-label="Mở menu tài khoản"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
        {children}

        {showDualLiveFeeds ? (
          <>
            <HackerLiveFeed side="left" variant="terminal" />
            <HackerLiveFeed side="right" variant="live" />
          </>
        ) : null}
      </div>

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
}
